import { frontendURL } from 'dashboard/helper/URLHelper';
import KanbanView from './KanbanView.vue';

const KANBAN_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_view',
    meta: {
      permissions: KANBAN_PERMISSIONS,
    },
    component: KanbanView,
  },
];
